import { MenuPanel } from './components/MenuPanel';
import { IMG_BASE } from './data/constants';

const appElement = document.getElementById('app');

// ── ローディング: マップアニメーションを全て一時停止 ──────────
document.body.classList.add('is-loading');

// ── DOM 挿入の基準アンカー ────────────────────────────────
const loadingOverlay = document.getElementById('loading-overlay');

// ── ヘッダー（ロゴ + メニューボタン）─────────────────────
const header = document.createElement('header');
header.id = 'app-header';

const menuButton = document.createElement('button');
menuButton.id = 'menu-btn';
menuButton.setAttribute('aria-label', 'メニューを開く');
menuButton.innerHTML = `
  <span class="menu-btn__icon"><span></span><span></span></span>
  <span class="menu-btn__label">MENU</span>
`;
header.appendChild(menuButton);

const logoWrapper = document.createElement('div');
logoWrapper.id = 'logo';
logoWrapper.innerHTML = `<img src="${IMG_BASE}/logo.webp" alt="解放美区 The Beauty District" width="343" height="99" />`;
header.appendChild(logoWrapper);

// ヘッダーは #app の先頭
appElement.insertBefore(header, appElement.firstChild);

// ── ロゴ位置（即座に左上へ）──
logoWrapper.classList.add('logo--small');

// ── MenuPanel ──────────────────────────────────────────
const menuPanel = new MenuPanel();
menuButton.addEventListener('click', () => menuPanel.toggle());
